
import { ValidationObserver } from 'vee-validate'
import { Component, Prop, Mixins} from 'vue-property-decorator'
import Common from '@/mixins/common'
import EventListInMembers from '@/components/EventListInMembers.vue'
import { EventData, MemberMeta } from '@/common-datatypes'
import EventDetails from '@/components/EventDetails.vue'
import ModalEditEvent from '@/components/ModalEditEvent.vue'
import { DateTime } from 'luxon'

@Component({
  components: {
    EventListInMembers,
    EventDetails,
    ModalEditEvent
  }
})

export default class ModalCreateEventByScheduling extends Mixins(Common) {
  @Prop({type: Array, default: () => {return []}}) private memberUserIds?: string[]
  @Prop({type: Object, default: () => {return {}}}) private memberMeta?: { [key: string]: MemberMeta}
  @Prop({type: Date, default: new Date()}) private startDate?: Date

  isActive = true

  isLoading = false

  title = ''

  showModalEditEvent = false

  $refs!: {
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  eventData = {} as EventData

  onConfirm(yes: boolean) {
    this.$emit("onConfirm", yes);
  }
  
// eslint-disable-next-line
  onEditEvent(event: EventData | boolean) {
    //this.onConfirm(false)
    this.showModalEditEvent = false
  }

  selectTemplateEvent(event: EventData) {
    if(! this.startDate){
      return
    }
    const start = DateTime.fromJSDate(event.start)
    const end = DateTime.fromJSDate(event.end)
    const diff = end.diff(start,'minutes')

    const startDate = DateTime.fromJSDate(this.startDate)
    
    this.eventData = {
      ...event,
      id: '',
      start: this.startDate || new Date(),
      end: startDate.plus(diff).toJSDate(),
      note: '',
      extendedProps:{
        ...event.extendedProps,
        docId: ''
      },
    }
  }

}
